import { render, staticRenderFns } from "./NormatifAnswers.vue?vue&type=template&id=6a627a8e&scoped=true&"
import script from "./NormatifAnswers.vue?vue&type=script&lang=js&"
export * from "./NormatifAnswers.vue?vue&type=script&lang=js&"
import style0 from "./NormatifAnswers.vue?vue&type=style&index=0&id=6a627a8e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a627a8e",
  null
  
)

export default component.exports